import { render, staticRenderFns } from "./register-plans.vue?vue&type=template&id=6c10add2&"
import script from "./register-plans.vue?vue&type=script&lang=js&"
export * from "./register-plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports